import React, { Component } from 'react';
import './Banner.css'

declare var $

class Banner extends Component {
   constructor(props) {
     super(props)
     this.state = { image: "https://cdn.dribbble.com/users/45010/screenshots/2209809/food_icon_ani.gif"  , loading: true};
     this.clickContinue = this.clickContinue.bind(this)
   }

   componentWillMount() {
     $(window).resize(() => {
        this.setImage(this.props)
     });
   }

   componentDidMount() {
    $(".button-collapse").sideNav();
     if(this.props.dataCoupon.image_url) {
      this.componentWillReceiveProps(this.props)
     }
   }

   componentWillReceiveProps(nextProps) {
      this.setState({
         image: nextProps.dataCoupon.image_url ,
         loading: false
       });
      this.setImage(nextProps)
   }

   setImage(data) {
     var image;
     if ($(window).width() < 730) {
       image =  data.dataCoupon.resp_image_url
    } else {
      image = data.dataCoupon.image_url
    }
    this.setState({
       image
     });
   }

  clickContinue() {
    // this.props.screen(screen)
    let step = this.props.step
    step++
    this.props.continue(step)
  }

  render() {
    var divImage = {
       backgroundImage : `url(${this.state.image})`
     };
    return (
      <div>
      <header>
      <div className="navbar-fixed">
          <nav>
           <div className="nav-wrapper">
             <a href="#!" className="brand-logo center"><img src="assets/img/logo.png" alt=""/></a>
             <a href="#" data-activates="mobile-demo" className="button-collapse"><i className="material-icons">menu</i></a>
           </div>
          </nav>
       </div>
       <ul className="side-nav" id="mobile-demo">
          <li><img src="assets/img/logo-rappi.png"/></li>
          <li><a className="waves-effect  waves-green" href="badges.html"> <img src="assets/img/googleplay.png"/>  Google Play</a></li>
          <li><a className="waves-effect  waves-green" href="collapsible.html"> <img  className="apple" src="assets/img/appstore.png"/>  App Store</a></li>
          <li><a  className="waves-effect  waves-green" href="mobile.html">www.rappi.com</a></li>
          <li><div className="divider"></div></li>
          <li><a className="waves-effect waves-green">Pedir ya!</a></li>
        </ul>
      </header>
      <section className="intro">
        <div id="background" style={divImage}></div>
        <div className="promo-img" className="center">
        <img src={this.state.image}/>
        </div>
      </section>
      <div className="call-to-action row">
        { /* <div className="col s6">
            <a onClick={ () => this.clickContinue() } className="waves-effect waves-light btn"> Ingresar </a>
        </div>  */ }
        <div className="col s12">
            <a onClick={() => this.clickContinue()} className="waves-effect waves-light btn btn-inverse">  <span className="animated shake infinite">  PEDIR YA! </span> </a>
        </div>
      </div>
      </div>
    );
  }

}


export default Banner;



// WEBPACK FOOTER //
// ./src/components/banner/Banner.js